import { useLayoutEffect, useState } from 'react';

const useTheme = function() {
  const [theme, setTheme] = useState(() => {
    try {
      const saved = localStorage.getItem('stickii-theme');

      if (saved === 'dark' || saved === 'light') return saved;
    } catch {
      // Theme selection still works when browser storage is unavailable.
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useLayoutEffect(() => {
    document.documentElement.dataset.theme = theme;

    const meta = document.querySelector('meta[name="theme-color"]');

    if (meta) meta.content = theme === 'dark' ? '#20231f' : '#f5f3ed';

    try {
      localStorage.setItem('stickii-theme', theme);
    } catch {
      // Theme selection still works when browser storage is unavailable.
    }
  }, [theme]);

  return {
    theme,
    toggleTheme: () => setTheme(value => value === 'dark' ? 'light' : 'dark')
  };
};

export default useTheme;
